import PouchDB from "pouchdb";
import _ from "lodash";
export default {
  async pull(params) {
    const db = new PouchDB(params.dbName);
    const remote = `${location.origin}/neocloud`;
    try {
      // 通过检查数据库是否有文档来判断是否首次同步
      const info = await db.info();
      console.log("==== db info: ", info);
      const isFirstSync = info.doc_count === 0;

      const opts = {
        retry: true,
        batch_size: 100,
        filter: "sync_gateway/bychannel",
        query_params: {
          channels: params.channels,
        },
      };

      // 只在首次同步时设置 since
      if (isFirstSync) {
        opts.since = "0";
      }

      const rep = await db.replicate.from(remote, opts);
      console.log("==== pull rep: ", rep);
      return rep;
    } catch (err) {
      console.log("==== pull error: ", err);
      console.error(err);
    }
  },

  async push(dbName, docIds) {
    const db = new PouchDB(dbName);
    const remote = `${location.origin}/neocloud`;
    // 传 docIds 时只推指定文档（单条发送/批量补救）；不传时全量增量推
    const opts = docIds && docIds.length ? { doc_ids: docIds } : {};
    try {
      const rep = await db.replicate.to(remote, opts);
      return rep;
    } catch (error) {
      throw new Error(error);
    }
  },

  // 获取书库数据
  async getLibraryChannel(params) {
    const db = new PouchDB(`${params.dbName}`);
    let data = await db.allDocs({
      include_docs: true,
    });
    /**
     * modeType
     * 1：批注
     * 2：书签
     * 3：书架
     * 4：书籍
     */
    let arr = data.rows
      .map((item) => item.doc)
      .filter((item) => item.status === 0);
    arr = _.orderBy(arr, ["updatedAt"], ["desc"]);
    let annotation = arr.filter((item) => item.modeType === 1);
    let bookMark = arr.filter((item) => item.modeType === 2);
    let library = arr.filter((item) => item.modeType === 3);
    let metadata = arr.filter((item) => item.modeType === 4);
    let res = { annotation, bookMark, library, metadata };
    console.log("======channelData: ", res);
    return res;
  },

  async getChannel(params) {
    const db = new PouchDB(`${params.dbName}`);
    let data = await db.allDocs({
      include_docs: true,
    });
    let arr = data.rows.map((item) => {
      item.doc.updatedAt = new Date(item.doc.updatedAt).getTime();
      return item.doc;
    });
    arr = _.orderBy(arr, ["updatedAt"], ["desc"]);
    return arr;
  },
};
